import { render } from "./IInput.vue?vue&type=template&id=25674b58"
import script from "./IInput.vue?vue&type=script&lang=js"
export * from "./IInput.vue?vue&type=script&lang=js"

import "./IInput.vue?vue&type=style&index=0&id=25674b58&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__